import { render, staticRenderFns } from "./SalePageAction.vue?vue&type=template&id=6c47dde6&scoped=true&"
import script from "./SalePageAction.vue?vue&type=script&lang=js&"
export * from "./SalePageAction.vue?vue&type=script&lang=js&"
import style0 from "./SalePageAction.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SalePageAction.vue?vue&type=style&index=1&id=6c47dde6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c47dde6",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VList,VMenu})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c47dde6')) {
      api.createRecord('6c47dde6', component.options)
    } else {
      api.reload('6c47dde6', component.options)
    }
    module.hot.accept("./SalePageAction.vue?vue&type=template&id=6c47dde6&scoped=true&", function () {
      api.rerender('6c47dde6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SalePage/components/SalePageAction.vue"
export default component.exports